import { render, staticRenderFns } from "./Postgrado-mod.vue?vue&type=template&id=453928a8&scoped=true"
import script from "./Postgrado-mod.vue?vue&type=script&lang=js"
export * from "./Postgrado-mod.vue?vue&type=script&lang=js"
import style0 from "./Postgrado-mod.vue?vue&type=style&index=0&id=453928a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453928a8",
  null
  
)

export default component.exports